function normalizeTargetName(locale, label) {
  var name = String(label || '').trim()
  if (!name) return ''

  // Strip already-applied free-trial wrappers first.
  if (locale === 'zh') {
    name = name.replace(/^免费试用\s*/, '')
    name = name.replace(/^打开\s*/, '').replace(/\s*试一版$/, '')
  } else if (locale === 'en') {
    name = name.replace(/\s+for Free$/i, '')
    name = name.replace(/^(Try|Open|Use)\s+/i, '')
    name = name.replace(/\s+online$/i, '')
  } else if (locale === 'ja') {
    name = name.replace(/を無料で試す$/, '')
    name = name.replace(/をオンラインで試す$|を試す$|を開く$/, '')
  } else if (locale === 'ko') {
    name = name.replace(/\s*무료 체험$/, '')
    name = name.replace(/\s*(온라인 사용|사용하기|열기)$/, '')
  } else if (locale === 'fr') {
    name = name.replace(/\s+gratuitement$/i, '')
    name = name.replace(/^(Essayer|Ouvrir)\s+/i, '').replace(/\s+en ligne$/i, '')
  } else if (locale === 'es') {
    name = name.replace(/\s+gratis$/i, '')
    name = name.replace(/^(Probar|Abrir)\s+/i, '').replace(/\s+online$/i, '')
  } else if (locale === 'it') {
    name = name.replace(/\s+gratis$/i, '')
    name = name.replace(/^(Prova|Apri)\s+/i, '').replace(/\s+online$/i, '')
  } else if (locale === 'de') {
    name = name.replace(/\s+kostenlos testen$/i, '')
    name = name.replace(/\s+(testen|öffnen)$/i, '').replace(/\s+online$/i, '')
  } else if (locale === 'pt') {
    name = name.replace(/\s+grátis$/i, '')
    name = name.replace(/^(Testar|Abrir)\s+/i, '').replace(/\s+online$/i, '')
  } else if (locale === 'pl') {
    name = name.replace(/\s+za darmo$/i, '')
    name = name.replace(/^(Wypróbuj|Otwórz)\s+/i, '').replace(/\s+online$/i, '')
  } else if (locale === 'ar') {
    name = name.replace(/\s+مجانًا$/, '')
    name = name.replace(/^(جرّب|افتح)\s+/, '').replace(/\s+عبر الإنترنت$/, '')
  }

  return name.trim()
}

function looksLikeFreeTrialLabel(locale, label) {
  var value = String(label || '').trim()
  if (!value) return false
  if (locale === 'zh') return /^免费试用\s+/.test(value)
  if (locale === 'en') return /^Try\s+.+\s+for Free$/i.test(value)
  if (locale === 'ja') return /を無料で試す$/.test(value)
  if (locale === 'ko') return /\s무료 체험$/.test(value)
  if (locale === 'fr') return /^Essayer\s+.+\s+gratuitement$/i.test(value)
  if (locale === 'es') return /^Probar\s+.+\s+gratis$/i.test(value)
  if (locale === 'it') return /^Prova\s+.+\s+gratis$/i.test(value)
  if (locale === 'de') return /\s+kostenlos testen$/i.test(value)
  if (locale === 'pt') return /^Testar\s+.+\s+grátis$/i.test(value)
  if (locale === 'pl') return /^Wypróbuj\s+.+\s+za darmo$/i.test(value)
  if (locale === 'ar') return /^جرّب\s+.+\s+مجانًا$/.test(value)
  return false
}

function formatFreeTrialLabel(locale, label, template) {
  var raw = String(label || '').trim()
  if (!raw) return raw
  if (looksLikeFreeTrialLabel(locale, raw)) return raw

  var name = normalizeTargetName(locale, raw)
  if (!name) return raw
  return String(template || 'Try {name} for Free').replace('{name}', name)
}

function applyFreeTrialTarget(article, locale, template) {
  if (!article || !article.target || !article.target.label) return article
  var nextLabel = formatFreeTrialLabel(locale, article.target.label, template)
  article.target = Object.assign({}, article.target, {
    label: nextLabel
  })
  // Keep embedded CTA buttons in sync with the list / primary CTA label.
  if (article.sections && article.sections.length) {
    var si
    var bi
    for (si = 0; si < article.sections.length; si++) {
      var section = article.sections[si]
      if (!section || !section.blocks) continue
      for (bi = 0; bi < section.blocks.length; bi++) {
        var block = section.blocks[bi]
        if (!block || block.type !== 'cta' || !block.buttonLabel) continue
        if (block.buttonPath && article.target.path && block.buttonPath !== article.target.path) {
          continue
        }
        block.buttonLabel = formatFreeTrialLabel(locale, block.buttonLabel, template)
      }
    }
  }
  return article
}

function applyFreeTrialLinks(links, locale, template) {
  return (links || []).map(function (item) {
    if (!item) return item
    return Object.assign({}, item, {
      label: formatFreeTrialLabel(locale, item.label, template)
    })
  })
}

module.exports = {
  normalizeTargetName: normalizeTargetName,
  looksLikeFreeTrialLabel: looksLikeFreeTrialLabel,
  formatFreeTrialLabel: formatFreeTrialLabel,
  applyFreeTrialTarget: applyFreeTrialTarget,
  applyFreeTrialLinks: applyFreeTrialLinks
}
